/**
 * TestCertificatePage - Test certificate viewer
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, FileText, ArrowRight, Download } from 'lucide-react';
import Header from '../components/shared/Header';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TestCertificatePage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const loadTestCertificate = () => {
    setLoading(true);
    // Set test data in session storage
    sessionStorage.setItem('relationship_id', '6781d821-b530-46c7-92c7-5a50b62b5e6f');
    sessionStorage.setItem('user_id', 'fdbabe01-8ef7-4aa4-ad31-3b474518d728');
    
    setTimeout(() => {
      navigate('/certificate');
    }, 500);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="flex items-center justify-center p-6" style={{minHeight: 'calc(100vh - 100px)'}}>
        <div className="max-w-lg w-full bg-white rounded-2xl border border-stone-100 shadow-sm p-12 text-center">
          <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <FileText className="w-8 h-8 text-purple-600" />
          </div>
          
          <h2 className="text-3xl font-bold text-stone-900 mb-4">Test Certificate Viewer</h2>
          
          <p className="text-stone-600 mb-4">
            View a pre-generated test certificate with complete flow and signatures.
          </p>

          <div className="bg-stone-50 rounded-xl p-4 mb-8">
            <p className="text-sm text-stone-600 text-left">
              <strong>Certificate ID:</strong> MC-CORE-20260211-82761B<br/>
              <strong>Partners:</strong> Sarah Williams & Michael Chen<br/>
              <strong>Level:</strong> CORE ($97)<br/>
              <strong>Status:</strong> Complete with signatures ✓
            </p>
          </div>

          <button
            onClick={loadTestCertificate}
            disabled={loading}
            className="w-full bg-mc-blue-deep text-white hover:bg-mc-blue-dark rounded-full px-8 py-4 text-lg font-medium transition-all hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 inline-flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin" />
                Loading...
              </>
            ) : (
              <>
                View Test Certificate
                <ArrowRight className="w-5 h-5" />
              </>
            )}
          </button>

          <div className="mt-6">
            <a
              href={`${BACKEND_URL}/api/certificates/6781d821-b530-46c7-92c7-5a50b62b5e6f/download`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-stone-600 hover:text-stone-900 underline flex items-center justify-center gap-2"
            >
              <Download className="w-4 h-4" />
              Or Download PDF Directly
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestCertificatePage;
